var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ltv-header"},[(_vm.isMobileScreen)?_c('MobileHeader',{attrs:{"is-live":""}}):_c('DesktopHeader',{attrs:{"is-live":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }